/**
 * Triage status for a stored/deduped error (see `errorsTable` in the server schema and the
 * super-admin errors surface). Mirrors the model used in the sibling `medicos` project:
 *
 *   - `active`   → an open, un-triaged error. This is the default for a freshly captured error and
 *                  the state a resolved error REGRESSES back into when it recurs (see effectiveStatus
 *                  in errors.service.ts): a resolved issue whose latest occurrence is newer than the
 *                  moment it was resolved reads as active again.
 *   - `ignored`  → deliberately muted; stays muted forever regardless of new occurrences (noise, a
 *                  third-party/browser-extension error we can't fix, etc.).
 *   - `resolved` → believed fixed. Recurrence after `statusChangedAt` flips it back to active.
 *
 * The backend stores the RAW status; consumers derive the effective status. Keep this list in sync
 * with the `error_status` pgEnum in apps/server/src/common/db-schema.ts.
 */
export const ERROR_STATUSES = ['active', 'ignored', 'resolved'] as const
export type ErrorStatus = (typeof ERROR_STATUSES)[number]

/** Where an error was captured: a server-side 500 or an uncaught client (browser) error. */
export const ERROR_ORIGINS = ['server', 'client'] as const
export type ErrorOrigin = (typeof ERROR_ORIGINS)[number]
